import React from 'react';
import { Modal, Row, Col, Select, Button, message } from 'antd';
import API_URL from '../../../../common/url';
import AjaxRequest from '../../../../common/AjaxRequest';

const confirm = Modal.confirm;
const Option = Select.Option;

class CutOffList extends React.Component {
    state = {
        countList: [],
    }

    getCountList = (value, index) => {
        const { handleCountChange } = this.props;
        handleCountChange(value, index);

        this.fetch(value);
    }

    fetch = (value, callback) => {
        const options = {
            url: `${API_URL.plan.queryVisitingFrequencyList}`,
            data: {
                configValue: value,
                limit: 999,
            },
            dataType: 'json',
            doneResult: ( res => {
                res = res.visitingFrequencyList;
                const countList = [];
                res.map((item) => {
                    countList.push({
                        visitTypeName: item.configValue
                    });
                });
                this.setState({
                    countList,
                })
            }),
        };
        AjaxRequest.sendRequest(options);
    }

    handleFocus = index => {
        const { cutoffList } = this.props;
        //cutoffList有值时，不调接口;
        if (cutoffList[index].visitTypeName) {
            return;
        }
        this.fetch('');
    }

    render () {
        const { countList } = this.state;
        const { item, index } = this.props;
        const countOptions = countList.map(item => <Option key={item.visitTypeName}>{item.visitTypeName}</Option>);
        return (
            <Row style={{borderBottom: '1px solid #ccc', margin: '10px 40px'}}>
                <Col span={10} style={{textAlign: 'center', marginTop: 6}}>{item.visitName}</Col>
                <Col span={14} style={{textAlign: 'center'}}>
                    <Select
                        allowClear={true}
                        style={{width: 160}}
                        placeholder='请输入'
                        onChange={(value) => this.getCountList(value, index)}
                        onFocus={() => this.handleFocus(index)}
                    >
                        {countOptions}
                    </Select>
                </Col>
            </Row>
        )
    }
}

class CutOff extends React.Component {
    state = {
        cutoffList: [],
        isSubmit: true,
        visible: false,
        confirmLoading: false,
    };
    
    show = () => {
        this.loadData();

        this.setState({
            visible: true,
        })
    };

    hide = () => {
        this.setState({
            visible: false,
            cutoffList: [],
        });
    };

    loadData = () => {
        const { visitGroupingId } = this.props;
        const options = {
            url: API_URL.plan.visitTypeDataList,
            data: { visitGroupingId },
            dataType: 'json',
            doneResult: res => {
                res = res.data.visitTypeList;
                const cutoffList = [];
                res.map(item => {
                    cutoffList.push({
                        visitTypeId: item.visitTypeId,
                        visitName: item.visitTypeName,
                    });
                });
                this.setState({ cutoffList });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    submit = () => {
        const { cutoffList } = this.state;
        const { visitGroupingId } = this.props;
        let str = '';

        cutoffList.map(item => {
            str += 'params[' + item.visitTypeId + ']=' + item.visitTypeName + '&';
        })
        str = str.slice(0, -1);

        this.setState({confirmLoading: true});

        const options = {
            url: `${API_URL.plan.visitTypeCutoff}?${str}`,
            data: { visitGroupingId },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.setState({
                    visible: false,
                    confirmLoading: false
                });
                this.props.loadData();
            },
            errorResult: (() => {
                this.setState({
                    confirmLoading: false,
                });
            }),
            failResult: (() => {
                this.setState({ confirmLoading: false });
            }),
        };
        AjaxRequest.sendRequest(options);
    }

    handleCountChange = (value, index) => {
        const { cutoffList } = this.state;
        cutoffList[index].visitTypeName = value;
        this.setState({ cutoffList });
    }

    getCutOffContent = () => {
        const { cutoffList } = this.state;
        return (
            <div>
                {
                    cutoffList.map((item, index) => (
                        <CutOffList key={item.visitTypeId} item={item} index={index} cutoffList={cutoffList} handleCountChange={this.handleCountChange}/>
                    ))
                }
            </div>
        )
    }

    showConfirm = () => {
        let { cutoffList, isSubmit } = this.state;
        //遍历更新后访视次数是否全部填写
        isSubmit = cutoffList.every(item => {
            return !!item.visitTypeName;
        });
        this.setState({
            isSubmit
        }, () => {
            if (!isSubmit) {
                message.error('更新后访视次数尚未全部填写');
                return;
            }
            let str = '', _this = this;
            cutoffList.map((item, index) => {
                str += item.visitName + ' -> ' + item.visitTypeName + ' ; '
            })

            confirm({
                title: (<span>是否确认以下调整? <span style={{color: '#F00'}}>(割接调整只能执行一次)</span></span>),
                iconType: 'exclamation-circle',
                content: str,
                onOk () {
                    _this.submit();
                },
                onCancel () {
                },
            });
        });
    }

    render() {
        const { visible, confirmLoading } = this.state;
        return (
            <Modal
                title='访视次数割接调整'
                visible={visible}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
                confirmLoading={confirmLoading}
                footer={[
                    <Button key="back" onClick={this.hide}>取消</Button>,
                    <Button key="submit" type="primary" loading={confirmLoading} onClick={this.showConfirm}>确定</Button>,
                ]}
            >
                <Row style={{margin: '0 40px', minHeight: '20px', fontWeight: 'bold'}}>
                    <Col span={6} offset={4} style={{textAlign: 'left'}}>现有访视</Col>
                    <Col span={14} style={{textAlign: 'center'}}>更新后访视次数</Col>
                </Row>
                {
                    this.getCutOffContent()
                }
            </Modal>
        );
    }
}

export default CutOff;



// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/CutOff.js